import { ClearingSaleBuyerStatus } from "constants/clearingSaleAttributes";
import { PaymentMethod } from "constants/payments";

// An empty selection means no filtering - matches every buyer.
export function getStatusFilter(
  selectedStatuses: readonly ClearingSaleBuyerStatus[],
): (buyerStatus: ClearingSaleBuyerStatus) => boolean {
  if (selectedStatuses.length === 0) {
    return () => true;
  }
  return buyerStatus => selectedStatuses.includes(buyerStatus);
}

// An empty selection means no filtering - matches every buyer.
export function getPaymentMethodFilter(
  selectedMethods: readonly PaymentMethod[],
): (buyerPaymentMethods: readonly PaymentMethod[]) => boolean {
  if (selectedMethods.length === 0) {
    return () => true;
  }
  return buyerPaymentMethods =>
    buyerPaymentMethods.some(method => selectedMethods.includes(method));
}

// An empty selection means no filtering - matches every buyer.
export function getBuyerFilter(
  selectedBuyerIds: readonly string[],
): (buyerId: string) => boolean {
  if (selectedBuyerIds.length === 0) {
    return () => true;
  }
  return buyerId => selectedBuyerIds.includes(buyerId);
}
